import endpoints, { ENDPOINT_NAMES } from '../../config/endpoints';
import STUDENT_FEATURES from '../../constants/student-features.json';
import { useData } from '@llt-frontend/react-fetch';
import useUserContext from '../context/use-user-context';

//

const REFETCH_INTERVAL = 60_000;

function useStudySupportEssays() {
  const { activeStudent } = useUserContext();

  const { path, key } = endpoints.get(ENDPOINT_NAMES.studySupportEssayRequests, {
    studentId: activeStudent.uuid,
  });

  const queryEnabled = Boolean(activeStudent?.getEnablement(STUDENT_FEATURES.essayEditing));

  return useData(path, {
    queryKey: key,
    queryOptions: {
      enabled: queryEnabled,
      refetchInterval: REFETCH_INTERVAL,
    },
  });
}

// Exports
// -------

export default useStudySupportEssays;
